import React from "react";
import s from "./style.module.css";
import Container from "../../Container";

const Footer = (props) => {
  return false;

  return (
    <footer className={s.wrap}>
      <Container>
        <div className={s.footer}>
          <p className={s.copy}>© 2021 Appcast All Rights Reserved.</p>
          <div className={s.nav}>
            <a
              href="https://www.appcast.io/privacy-policy/"
              className={s.link}
              rel="nofollow"
            >
              Privacy
            </a>
            <a
              href="https://www.appcast.io/legal/"
              className={s.link}
              rel="nofollow"
            >
              Legal
            </a>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
